// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgAlertsIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M10.004 20.01h4c0 1.1-.9 2-2 2s-2-.9-2-2m9.71-2.71-1.71-1.71V10c0-2.97-2.17-5.43-5-5.91V3c0-.55-.45-1-1-1s-1 .45-1 1v1.09c-2.83.48-5 2.94-5 5.91v5.59l-1.71 1.71c-.29.29-.37.72-.22 1.09s.52.62.92.62h14c.4 0 .77-.24.92-.62.16-.37.07-.8-.22-1.09z" />
  </g>
);
export default SvgAlertsIcon;
SvgAlertsIcon.displayName = 'SvgAlertsIcon';
